var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 8.31667H16.6667C17.125 8.31667 17.5 8.69167 17.5 9.15V16.3333C17.5 16.7917 17.125 17.1667 16.6667 17.1667H15.3333C14.875 17.1667 14.5 16.7917 14.5 16.3333V9.15C14.5 8.68334 14.875 8.31667 15.3333 8.31667Z",
    fill: "#8EE1E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 5.65828H10.6667C11.125 5.65828 11.5 6.03328 11.5 6.49162V16.3333C11.5 16.7916 11.125 17.1666 10.6667 17.1666H9.33333C8.875 17.1666 8.5 16.7916 8.5 16.3333V6.49162C8.5 6.03328 8.875 5.65828 9.33333 5.65828Z",
    fill: "#C9CECF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 3H4.66667C5.125 3 5.5 3.375 5.5 3.83333V16.3333C5.5 16.7917 5.125 17.1667 4.66667 17.1667H3.33333C2.875 17.1667 2.5 16.7917 2.5 16.3333V3.83333C2.5 3.375 2.875 3 3.33333 3Z",
    fill: "#C9CECF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/Level.0584d316ba361199fa700713c345ae1e.svg";
export { ForwardRef as ReactComponent };